type extras = {
  all?: any,
  [key: string]: any
}

export interface ColumnOption {
  header: string;
  key: string;
  style?: extras;
  class?: extras;
  sortable?: boolean;
}

/**
 * **************************************************
 * Class for column info
 * **************************************************
 */
export class Column {

  header: string;
  key: string;
  style: extras;
  class: extras;
  sortable: boolean;

  constructor(options: ColumnOption) {
    this.header = options.header;
    this.key = options.key;
    this.style = this.appendAllObj(options.style);
    this.class = this.appendAllList(options.class)
    this.sortable = options.sortable == undefined || options.sortable;
  }

  appendAllObj(extras: extras | undefined) {
    let property = { ...extras };
    for (let extra in extras) {
      if (extra != 'all') {
        property[extra] = { ...extras?.all, ...extras[extra] };
      }
    }
    return property;
  }

  appendAllList(classes: extras | undefined) {
    let property = { ...classes };
    for (let extra in classes) {
      if (extra != 'all' && classes.all) {
        property[extra].push(...classes.all)
      }
    }
    return property;
  }
}